import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import { Logo } from "../../components/Logo";
import { MAIN_ROUTES } from "../MAIN_ROUTES";
import {
  Box,
  Burger,
  Button,
  Container,
  Divider,
  Drawer,
  Flex,
  Group,
  Header,
  MediaQuery,
  useMantineColorScheme,
} from "@mantine/core";
import ColorSchemeToggleActionButton from "@/components/ColorSchemeToggleActionButton";
import { CompanyLogo } from "@/components/CompanyLogo";

const MainNavbar = ({ opened, toggle, isTransparent }) => {
  const { colorScheme } = useMantineColorScheme();
  const navigate = useNavigate();

  const HEADER_HEIGHT = 60;
  const isLight = colorScheme === "light";

  const renderDesktopRoutes = MAIN_ROUTES.map((item) => (
    <NavLink to={item.url} key={item.title}>
      {({ isActive }) => (
        <Button
          variant={isActive ? "light" : "subtle"}
          color={isActive ? "brand" : "dark"}
          sx={(theme) => ({ "&:hover": { backgroundColor: isLight ? theme.colors.gray[2] : theme.colors.dark[6] } })}
          leftIcon={item.icon}
        >
          {item.title}
        </Button>
      )}
    </NavLink>
  ));

  const renderMobileRoutes = MAIN_ROUTES.map((item) => (
    <NavLink to={item.url} key={item.title}>
      {({ isActive }) => (
        <Button
          fullWidth
          styles={{ inner: { justifyContent: "flex-start" }, root: { height: "3rem" } }}
          variant={isActive ? "light" : "subtle"}
          color={isActive ? "brand" : "dark"}
          leftIcon={item.icon}
        >
          {item.title}
        </Button>
      )}
    </NavLink>
  ));

  return (
    <Header height={HEADER_HEIGHT} p="xs" fixed withBorder>
      <Container fluid h="100%">
        <Flex align="center" h="100%" justify="center" gap={10}>
          {/* <MediaQuery largerThan="md" styles={{ display: "none" }}>
            <Burger opened={opened} onClick={toggle} size="sm" />
          </MediaQuery> */}
          {/* <Link to="/"> */}
          <CompanyLogo sx={{ height: 35, marginTop: -1 }} />
          {/* </Link> */}
          {/* <Box sx={{ flexGrow: 1 }} /> */}

          {/* Mobile Menu */}
          {/* <Drawer
            position="top"
            opened={opened}
            onClose={toggle}
            withCloseButton={false}
            overlayProps={{ opacity: 0.5, blur: 4 }}
            styles={{ content: { height: "unset !important", paddingTop: HEADER_HEIGHT } }}
          >
            {renderMobileRoutes}

            <Divider my="sm" />
            <Group>
              <Button size="md" variant="light" sx={{ flex: 1 }}>
                Hello
              </Button>
              <Button size="md" sx={{ flex: 1 }}>
                Hello
              </Button>
            </Group>
          </Drawer> */}

          {/* Desktop Menu */}
          {/* <Group sx={(theme) => ({ [theme.fn.smallerThan("md")]: { display: "none" } })}>
            {renderDesktopRoutes}
            <Divider size="sm" orientation="vertical" />

            <Button variant="filled" onClick={() => navigate("/admin")}>
              관리자
            </Button>
          </Group> */}

          {/* <ColorSchemeToggleActionButton /> */}
        </Flex>
      </Container>
    </Header>
  );
};

export default MainNavbar;
